import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { FC, ReactElement } from "react";
import { Processing } from "../../graphql/types";
import { HumanDate } from "../Date";
import { ProcessingStatusIcon } from "../TestRuns";
import IconCopy from "../common/IconCopy";
import { StatusTd, StatusTh } from "../ui/muiTables";
interface ProcessingRowProps {
  flow: Processing;
}

interface ProcessingTableProps {
  stats?: Processing;
}

const ProcessingRow: FC<ProcessingRowProps> = ({ flow }) => (
  <TableRow>
    <TableCell>
      <HumanDate className="started" date={flow.started} />
      <IconCopy tooltip={`Flows ID: ${flow.id}`} clipboard={`Flows ID: ${flow.id}`} />
    </TableCell>
    <TableCell>
      <HumanDate className="finished" date={flow.finished} />
    </TableCell>
    <StatusTd>
      <ProcessingStatusIcon status={flow.status} />
    </StatusTd>
  </TableRow>
);

const ProcessingTable: FC<ProcessingTableProps> = ({ stats }) => {
  let processingRow: ReactElement | null = null;

  if (stats) {
    processingRow = <ProcessingRow flow={stats} />;
  } else {
    processingRow = (
      <TableRow>
        <TableCell colSpan={3} className="tableMessage" key="0">
          No Processing Data
        </TableCell>
      </TableRow>
    );
  }

  return (
    <TableContainer component={Paper}>
      <Table className="table-striped" data-cy="flows-table" data-testid="flows-table" id="flows-table">
        <TableHead>
          <TableRow>
            <TableCell>Started</TableCell>
            <TableCell>Finished</TableCell>
            <StatusTh>Status</StatusTh>
          </TableRow>
        </TableHead>
        <TableBody>{processingRow}</TableBody>
      </Table>
    </TableContainer>
  );
};

export { ProcessingTable };
